import { fromJS } from 'immutable'
import typesApp from 'components'
import types from 'components/details/actions'
import typesAuth from 'components/auth/actions'
import typesPerson from 'components/people/person/actions'

export const initState = fromJS({})

const detailsByIdReducer = ($$state = initState, action) => {
  switch (action.type) {
    case types.DETAIL_CREATE_SUCCESS:
    case types.DETAIL_UPDATE_SUCCESS:
    case types.DETAIL_VERIFY_SUCCESS:
    case types.DETAIL_FETCH_SUCCESS:
    case typesPerson.PERSON_FETCH_SUCCESS:
    case typesAuth.SIGN_IN_SUCCESS:
    case typesApp.HYDRATE: {
      const entities = action.data.entities
      if (entities) {
        return $$state.mergeDeep(entities.details)
      }

      return $$state
    }

    case types.DETAIL_DESTROY_SUCCESS: {
      return $$state.delete(action.id)
    }

    default: {
      return $$state
    }
  }
}

export default detailsByIdReducer
